<template>
  <div v-if="me">
    <div v-if="filterBanks.length < 1" class="px-4">
      <section id="section__signup-bank-collection">
        <div class="mt-10">
          <label class="font-size--16">매출을 집금할 은행을 선택 해주세요</label>
          <v-autocomplete
            v-model="collection.bank"
            :items="filterBanks"
            item-text="name"
            item-value="value"
          ></v-autocomplete>
        </div>
        <template v-if="collectionBankComponentName">
          <component
            :is="collectionBankComponentName"
            :meCollection="collection"
            @emitNext="next"
          ></component>
        </template>
      </section>
    </div>
    <div v-else class="page-container mt-4">
      <section v-if="collectionBankComponentName" id="section__signup-bank-collection">
        <component
          :is="collectionBankComponentName"
          :meCollection="collection"
          @emitNext="next"
        ></component>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  components: {
    Bank39: () => import('@/components/bank/collection/BnkVer2.vue'),
    Bank88: () => import('@/components/bank/collection/Shinhan.vue'),
  },
  data() {
    return {
      collection: {
        bank: null,
        accountNumber: null,
        holderName: null,
      },
      banksObj: {},
      selBank: null,
    }
  },
  async created() {
    _meta({
      titles: ['매출집금계좌확인'],
    })

    console.log('************* bank/collection created')
    this.banksObj = await this.getBanks()
    console.log('************* banksObj', this.banksObj)
  },
  watch: {
    filterBanks: {
      handler() {
        if (!this.collection.bank && this.filterBanks.length === 1) {
          this.collection.bank = this.filterBanks[0].value
        }
      },
      immediate: true,
    },
    me: {
      immediate: true,
      deep: true,
      handler(v) {
        if (v) {
          const { collectionAccount } = v
          if (!!collectionAccount?.accountNumber) {
            this.collection = {
              ...this.collection,
              ...collectionAccount,
            }
          }
        }
      },
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('myfinbiz', ['organization']),
    banks() {
      const banks = []
      for (const k in this.banksObj) {
        banks.push({
          name: this.banksObj[k],
          value: k,
        })
      }
      return banks
    },
    collectionBankComponentName() {
      if (!this.collection.bank) return
      return `Bank${this.collection.bank}`
    },
    avilableBanks() {
      return this.organization.banks.map((b) => b.bank)
    },
    filterBanks() {
      return this.banks?.filter((bank) => this.avilableBanks.includes(bank.value)) || []
    },
  },
  methods: {
    ...mapActions('choice', ['getBanks']),
    ...mapActions('contract', ['contractComplete']),
    ...mapActions('auth', ['getMe']),
    async next() {
      if (await redirectSignupManage()) {
        return
      }

      await this.getMe() // me 갱신
      if( this.$route.query.next ) {
        return this.$router.replace(this.$route.query.next)
      }

      await this.$router.push({ name: 'signup/certification' })
    },
  },
}
</script>
